import React, { useEffect } from 'react';


export default function IC_mp_children({ data, entity, setDataKeyValue }) {

    useEffect(() => {
        if (data.idItemModel) {
            if (data.itemName !== data.idItemModel.name) {
                setDataKeyValue('itemName', data.idItemModel.name)
            }
            if (data.itemUdm !== data.idItemModel.measureUnit) {
                setDataKeyValue('itemUdm', data.idItemModel.measureUnit)
            }
            if (data.type !== data.idItemModel.type) {
                setDataKeyValue('type', data.idItemModel.type)
            }
        }
    }, [data]);

    return (
        <></>
    )
};
